import { Filter } from '@anytag/shared-molecules';
import { useMarketplaceApplicantsFilter } from './hooks';
import { BasicFilter, BasicFilterProps } from './BasicFilter';

export type MarketplaceApplicantsFilterProps = Omit<BasicFilterProps, 'onSubmit'>;

export const MarketplaceApplicantsFilter = (props: MarketplaceApplicantsFilterProps) => {
  const { filter, setFilterForm } = useMarketplaceApplicantsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none">
      <BasicFilter {...props} />
    </Filter.Provider>
  );
};

export { useMarketplaceApplicantsFilter };
export * from './schemaTypes';
